import { useRef } from 'react'
import { ImperativeHandle } from './EtcCell'

export const useEtcCellRef = () => {
  return useRef<ImperativeHandle>(null)
}
